import React from "react";
import { Text } from "web/react/emo/text/text";
import styles from "./oos-pill.module.css";

interface OOSPillProps {
    text: string;
}

function OOSPill({ text }: OOSPillProps): React.ReactElement {
    return (
        <div className={styles.oosPill}>
            <Text textStyle={"caption-2"} color={"grayscale0"}>
                {text}
            </Text>
        </div>
    );
}

export default OOSPill;
